/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../../app.core.module.js';
import twofaAppConfig from './2fa.app.config.js';
import twofaAppRoute from './2fa.app.route.js';
import twofaAppController from './2fa.app.controller.js';

/**
 * This is the 2fa module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace 2fa Module
 */
angular.module('twofactorApp', [
  // Shared modules.
  core
])
// Register config.
.config(twofaAppConfig)
// Register route.
.config(twofaAppRoute)
// Register controller.
.controller('twofaAppController', twofaAppController);

export default 'twofactorApp';


// WEBPACK FOOTER //
// ./src/login/2fa/app/2fa.app.module.js